module.exports = __webpack_public_path__ + "cb3daec2.png";